var exports = {
  "kL": "container__hjOUVP",
  "Qq": "text__CTntN_",
};

module.exports = exports;
